import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
import Alert from './Alert';

class YorumForm2 extends Component {
    constructor(props) {
        super(props);
        this.database = database.ref(`users`);
        this.database2 = database.ref(`yorumlar/${window.location.pathname.slice(2)}/${props.aydi}/yorumlar`);
        this.aydi = props.aydi;
        this.acik = props.acik;
        this.state = {
          newCommentAuthor: "",
          newCommentContent: "",
          newCommentDate: "",
          asdf: [],
          asdf2: [],
          open: false,
        }
        this.addComment = this.addComment.bind(this);
        this.writePost = this.writePost.bind(this);
        this.goster_open = this.goster_open.bind(this);
        this.goster_close = this.goster_close.bind(this);
        this.yap = this.yap.bind(this);
    }

    componentDidMount() {
      const abc = this.state.asdf2;
      this.database2.on('child_added', snap => {
        abc.push(snap.val())
        
        this.setState({
          asdf2: abc,
        })

        if (this.state.asdf2.length < 2) {
          document.getElementById("title"+this.aydi).style.display = "block";
          document.getElementById("yanıt-div"+this.aydi).style.display = "none";
          document.getElementById("title"+this.aydi).style.marginLeft = "0";
          document.getElementById("title"+this.aydi).style.marginTop = "-8px";
          document.getElementById("title"+this.aydi).style.position = "unset";
        } else {
          document.getElementById("title"+this.aydi).style.display = "block";
          document.getElementById("yanıt-div"+this.aydi).style.display = "none";
          document.getElementById("title"+this.aydi).style.marginLeft = "150px";
          document.getElementById("title"+this.aydi).style.marginTop = "-20px";
          document.getElementById("title"+this.aydi).style.position = "unset";
        }
      })

      const previousComments = this.state.asdf;
      this.database.on('child_added', snap => {
        previousComments.push({
          id: snap.key,
          name: snap.val().userName,
          image: snap.val().userImage,
        })
        
        this.setState({
          asdf: previousComments,
        })
      })

      this.database.on('child_removed', snap => {
          for (var i = 0; i < previousComments.length; i++) {
              if (previousComments[i].id === snap.key) {
                  previousComments.splice(i, 1);
              }
          }
          this.setState({
            asdf: previousComments,
          })
      })
    }

    addComment(yorum) {
      this.database2.push().set({
        commentAuthor: yorum.commentAuthor,
        commentContent: yorum.commentContent,
        commentDate: yorum.commentDate
      });
      
      database.ref(`yorumlar/${window.location.pathname.slice(2)}/${this.props.aydi}`).get().then((snap) => {
        if (auth.currentUser.uid !== snap.val().commentAuthor) database.ref("notifications/"+snap.val().commentAuthor).push().set({
          author: auth.currentUser.uid,
          date: Date.now(),
          okundu: false,
          post: window.location.pathname.slice(2),
          type: "yanıt"
        });
      })
    }

    writePost() {
      if (auth.currentUser === null) return this.yap();
      else if (this.state.newCommentContent == "") return;

      var data = {
        commentAuthor: auth.currentUser.uid,
        commentContent: this.state.newCommentContent,
        commentDate: Date.now(),
      };

      if(this.state.newCommentContent = "") {alert('Yorum Boş Olamaz')}
      else{this.addComment(data)}

      document.getElementById("title"+this.aydi).style.marginBottom = "10px";

      this.setState({
        newCommentAuthor: "",
        newCommentContent: "",
        newCommentDate: "",
      });
    }

    goster_open() {
      if (document.getElementById("yanıt-div"+this.aydi).style.display == "") 
        document.getElementById("yanıt-div"+this.aydi).style.display = "none";
      document.getElementById("yanıt-div"+this.aydi).style.display = "block";
      document.getElementById("title"+this.aydi).style.marginBottom = "0px";
    }

    goster_close() {
      document.getElementById("yanıt-div"+this.aydi).style.display = "none";
      document.getElementById("title"+this.aydi).style.marginBottom = "10px";
    }

    yap() {
      document.getElementById("input"+this.aydi).focus();
      if (this.state.open == false) this.setState({open: true});
      else this.setState({open: false});
    }

    render() {return (
      <div className="div2" id={"div2"+this.aydi} onClick={this.yap}>
        {auth.currentUser == null ? <Alert baslik="Üzgünüm!" 
            content="Bunun için giriş yapman gerekli!" 
            onay="Beni Oraya Götür!" 
            onayLink="/giris-yap"
            red="Anlıyorum..." 
            opened={this.state.open}/> : ""}
        <h4 className="title" id={"title"+this.aydi} style={this.acik == true ? {marginTop: "-5px"} : {marginTop: "-20px"}} onClick={this.goster_open}>Yanıtla</h4>
        <div className="yanıt-div" id={"yanıt-div"+this.aydi}>
          <input placeholder="Yanıt"
            className="input"
            id={"input"+this.aydi}
            value={this.state.newCommentContent} 
            onChange={event => this.setState({newCommentContent: event.target.value})}/>
          <button className="button-ipt" onClick={this.goster_close}>İPTAL</button>
          <button className="button" onClick={this.writePost}>YAYINLA</button>
        </div>
        <style>{`
           .div2 {
             padding: 0px 0;
             background: none;
             width: auto;
             margin: auto;
             border-top: 2px solid #fff;
           }

           .div2 h4 {
             cursor: pointer;
           }

           .yanıt-div {
             display: none;
             padding: 10px 0;
           }

           .title {
             position: absolute;
             margin-top: -40px;
             margin-left: 150px;
           }

           .input {
             border: 0;
             border-bottom: 4px solid #cccccc;
             padding: 10px;
             width: 250px;
             border-radius: 5px;
             resize: none;
             outline: none;
             transition: .2s;
           }

           .input:focus {
             border-bottom: 4px solid #F57029;
           }
           
           .button-ipt {
             border: 0;
             height: 100%;
             padding: 10px;
             border-radius: 0 8px 8px 0;
             outline: none;
             background: none;
             color: #000;
             transition: .2s;
             font-weight: bold;
           }

           .button {
             border: 0;
             height: 100%;
             padding: 10px;
             border-radius: 8px 0 0 8px;
             outline: none;
             background: none;
             color: #000;
             transition: .2s;
             font-weight: bold;
           }

           @media (max-width: 623px) {
             .input {
               width: 100px;
             }
           }
        `}</style>
      </div>
    )}
}

YorumForm2.propTypes = {
  aydi: PropTypes.string,
  acik: PropTypes.bool
}
export default YorumForm2;